import React, {Component} from "react"
import {clearBlogData, getPostsListsPage} from "../../store/actions/blogActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom"
import BlogCard from "./BlogCard";
import {withTranslate} from "react-redux-multilingual"
import {setBlogCardSkeleton} from "../../skeleton";
import BlogSidebar from "../blog/BlogSidebar";
import NoData from "../NoData";
import Maintenance from "../../components/Maintenance";
import NoMatch from "../../views/NoMatch";
import {clearError500} from "../../store/actions/globalActions";

class BlogPosts extends Component {

    componentDidMount() {
        this.props.clearError500();
        this.props.clearBlogData();
        this.props.getPostsListsPage(1, this.props.action, "", 3);
    }

    onPageClick(e, pageNumber) {
        e.preventDefault();
        this.props.clearBlogData();
        this.props.getPostsListsPage(pageNumber, this.props.action, "", 3);
        // window.scrollTo(0, 500)
    };

    handleSearch(keyword) {
        this.props.clearBlogData();
        this.props.getPostsListsPage(1, this.props.action, keyword, 3);
    }

    render() {
        const {posts, categories, tags, blogError500, postsIsLoading, lastPage, currentPage, nextPage, postsNotFound} = this.props;
        if (postsNotFound) {
            return (
                <NoMatch/>
            )
        }

        if (blogError500) {
            return (
                <Maintenance/>
            )
        }

        let
            pages = [];

        if (lastPage) {
            for (let i = 0; i < lastPage; i++) {
                pages.push(
                    <li className={currentPage === i + 1 ? "cursor-pointer active" : "cursor-pointer"}
                        key={i}
                        onClick={(e) => this.onPageClick(e, i + 1)}>
                        <span>{i + 1}</span>
                    </li>
                )
            }
        }

        const
            postsList = posts && posts.length ? posts.map((post, index) => {
                return (
                    <div className="col-md-6  pl-15" key={index}>
                        <BlogCard post={post}/>
                    </div>
                )
            }) : <NoData image="no_posts"/>;

        return (

            <div className="row">
                <div className="col-md-8 no-padding">
                    {postsIsLoading === false ?
                        <div className="container">
                            <div className="row">
                                {postsList}
                            </div>
                            <div className="row">
                                <div className="text-center">
                                    <div className="block-27">
                                        <ul>
                                            {currentPage === 1 || lastPage === 1 ? null :
                                                <li><a href="/"
                                                       onClick={(e) => this.onPageClick(e, (currentPage - 1))}>&lt;</a>
                                                </li>}

                                            {lastPage === 1 ? null : pages}

                                            {nextPage === null ? null :
                                                <li><a href="/" onClick={(e) => this.onPageClick(e, nextPage)}>&gt;</a>
                                                </li>}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> :
                        <div className="container">
                            <div className="row">
                                {setBlogCardSkeleton(2, 6)}
                            </div>
                        </div>
                    }
                </div>
                {
                    posts && posts.length ? <BlogSidebar handleSearch={(keyword) => this.handleSearch(keyword)}
                                                         slug={this.props.slug ? this.props.slug : ""}
                                                         categories={categories} tags={tags}
                                                         loading={postsIsLoading}/>
                        : null
                }

            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        posts: state.blog.posts,
        lastPage: state.blog.lastPage,
        currentPage: state.blog.currentPage,
        nextPage: state.blog.nextPage,
        categories: state.blog.categories,
        tags: state.blog.tags,
        postsIsLoading: state.blog.postsIsLoading,
        postsNotFound: state.blog.postsNotFound,
        blogError500: state.global.error500,

    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        getPostsListsPage: (page, queryString, keyword, limit) => dispatch(getPostsListsPage(page, queryString, keyword, limit)),
        clearBlogData: () => dispatch(clearBlogData()),
        clearError500: () => dispatch(clearError500())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslate(BlogPosts)))